import CricketBoxScore from "./CricketBoxScore";

export default CricketBoxScore;
